import { Spinner } from "react-bootstrap";
import { Input } from "../../Components/CustomComponents/index.js";
import { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader.js";

const SwitchWithLoader = ({ isChecked, onChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  // const [status, setStatus] = useState(true); // todo: Alpha
  useEffect(() => {
    setIsLoading(false);
  }, [isChecked]);

  const handler = async () => {
    setIsLoading(true);
    onChange();
    await new Promise((resolve) => setTimeout(resolve, 2000));
    // setStatus(!status);
    setIsLoading(false);
  };

  if (isLoading) {
    return <ClipLoader color="#0f0f0f" size="22px" />;
  }

  return (
    <label className="switch">
      <Input
        type="checkbox"
        checked={isChecked}
        // checked={status}
        disabled={isLoading} // Disable the switch while loading
        // onChange={onChange}
        onChange={handler}
      />
      <span className="slider round"></span>
      {isLoading && <ClipLoader color="#0f0f0f" size="22px" />}
    </label>
  );
};

export default SwitchWithLoader;
